import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import OwnerForm from '../../../components/forms/OwnerForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import GetAction from '../../../actions/owners/GetAction'
import PutAction from '../../../actions/owners/PutAction'
import ListUsersAction from '../../../actions/users/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class UpdateOwnerPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.get(this.props.id)
    this.props.fetchUsers()
  }

  componentDidUpdate(prevProps, prevState) {
    // If fetch is error, close with error
    if (
      prevProps.isLoading
      &&
      !this.props.isLoading
      &&
      this.props.loadError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.FAILURE, "Impossible d'obtenir les infos sur ce groupe matériel.")
      this.props.onClose(false)
    }

    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.saveError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Groupe matériel modifié.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.put(this.props.id, data)
  }

  render() {
    return (
      <Popup
        header='Modifier un groupe matériel'
        body={
          <OwnerForm
            data={this.props.data}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={this.props.isLoading}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.saveError}
            usersList={this.props.usersList}
            usersIsFetching={this.props.usersIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Modifier',
            color: 'orange',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

UpdateOwnerPopup.propTypes = {
  // Properties
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  data: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  loadError: PropTypes.object,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,
  usersList: PropTypes.array,
  usersIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  get: PropTypes.func.isRequired,
  put: PropTypes.func.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    data: state.entities.owners.get.data,
    isLoading: state.entities.owners.get.isFetching,
    loadError: state.entities.owners.get.error,
    isSaving: state.entities.owners.put.isFetching,
    saveError: state.entities.owners.put.error,
    usersList: state.entities.users.list.data,
    usersIsFetching: state.entities.users.list.isFetching
  }),
  (dispatch) => ({
    get: (id) => (dispatch(GetAction({ id }))),
    put: (id, data) => (dispatch(PutAction({ id, data }))),
    fetchUsers: () => (dispatch(ListUsersAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.BATTERIES.PUT)))
  })
)(UpdateOwnerPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/owners/UpdateOwnerPopup.js